import { useMediaQuery } from '@uidotdev/usehooks'
import { createContext, ReactNode } from 'react'

type ScreenSizeContextType = Record<'xs' | 'sm' | 'md' | 'lg' | 'xl', boolean>

type ScreenSizeProviderPropsType = {
  children: ReactNode
}

export const ScreenSizeContext = createContext<ScreenSizeContextType | null>(
  null
)

function ScreenSizeProvider({ children }: ScreenSizeProviderPropsType) {
  const xs = useMediaQuery('screen and (max-width: 575px)')
  const sm = useMediaQuery(
    'screen and (min-width: 576px) and (max-width: 767px)'
  )
  const md = useMediaQuery(
    'screen and (min-width: 768px) and (max-width: 991px)'
  )
  const lg = useMediaQuery(
    'screen and (min-width: 992px) and (max-width: 1199px)'
  )
  const xl = useMediaQuery('screen and (min-width: 1200px)')

  return (
    <ScreenSizeContext.Provider value={{ xs, sm, md, lg, xl }}>
      {children}
    </ScreenSizeContext.Provider>
  )
}

export default ScreenSizeProvider
